import React from "react";

interface DotProps {
    size?: string | number;
    className?: string;
}

export default function DotIcon(props: DotProps) {
    return (
		<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx="4" cy="4" r="3" fill="currentColor"/>
		</svg>
    );
}

